import { css } from '@emotion/css';
import {
  AlignItems,
  Color,
  Display,
  FlexDirection,
  Font,
  FontWeight,
  JustifyContent,
  ScreenBreakpoint,
  Spacing,
} from 'src/styles';

export const container = css`
  ${Spacing.px32}
  ${Spacing.py16}

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.px16}
    ${Spacing.py8}
  }
`;

export const card = css`
  ${Spacing.p32}
  ${Display.inlineBlck}
  width:100%;
  background-color: ${Color.Gray1};

  @media (max-width: ${ScreenBreakpoint.mobile.max}) {
    ${Spacing.p16}
  }
`;

export const section = css`
  ${Display.flex}
  ${JustifyContent.spaceBetween}
  ${Spacing.my16}
  ${AlignItems.center}

  @media (max-width: ${ScreenBreakpoint.mobile.min}) {
    ${FlexDirection.column}
    ${AlignItems.flexStart}
  }
`;

export const subTitle = css`
  ${Font.md}
  ${FontWeight.bold}
  color: ${Color.Gray8};
  /* No margin, so the next line sits against the title. */
  && {
    ${Spacing.m0}
  }
`;

export const paragraph = css`
  ${Font.md}
  ${FontWeight.normal}
  color: ${Color.Gray7};
  /* No top margin, so a bold title stays attached to the text under it. */
  && {
    ${Spacing.mt0}
    ${Spacing.mb16}
  }
`;

export const continuedParagraph = css`
  ${Font.md}
  ${FontWeight.normal}
  color: ${Color.Gray7};
  && {
    ${Spacing.mt16}
    ${Spacing.mb16}
  }
`;

export const highlight = css`
  ${FontWeight.bold}
  color: ${Color.Gray8};
`;

export const infoLinkButton = css`
  ${Spacing.pl0}
`;
